import { Injectable } from '@angular/core';
import { Params, RouterStateSnapshot, NavigationEnd } from '@angular/router';
import { routerReducer, RouterReducerState, RouterStateSerializer } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';
import { UserState, userReducer } from '../../store/user/user.reducer';

export interface RouterStateUrl {
  url: string;
  params: Params;
  queryParams: Params;
}

@Injectable()
export class CustomSerializer implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const {
      url,
      root: { queryParams }
    } = routerState;
    const { params } = route;

    // Only return an object including the URL, params and query params
    // instead of the entire snapshot
    return { url, params, queryParams };
  }
}

export interface RouteAction {
  type: string;
  payload?: { event: NavigationEnd; routerState: RouterStateUrl };
}

export interface AppState {
  router: RouterReducerState<RouterStateUrl>;
  user: UserState;
}

export const reducers: ActionReducerMap<AppState> = {
  router: routerReducer,
  user: userReducer
};
